import { MenuEntry } from '@src/menu-entry.js';

export default MenuEntry.create()
    .setTitle('Maileinstellungen')
    .setChildren([
        MenuEntry.create()
            .setRoute('mail_settings_payment_types_footer'),
        MenuEntry.create()
            .setRoute('sales_order_settings_bike_delay_mail'),
        MenuEntry.create()
            .setRoute('return_goods_settings_entry_mail'),
    ]);
